<script>
import MainLayout from "@/layouts/MainLayout.vue";
import CantonalMinimumWageOverview from "@/components/legalMinimumWage/LegalMinimumWageOverview.vue";

export default {
  name: "CantonalMinimumWagePage",
  components: { MainLayout, CantonalMinimumWageOverview },
};
</script>

<template>
  <MainLayout>
    <b-row id="criterionOverview">
      <b-col class="shadow-sm">
        <b-card-body>
          <cantonal-minimum-wage-overview />
        </b-card-body>
      </b-col>
    </b-row>
  </MainLayout>
</template>

<style scoped></style>
